<template>
  <div>
    <Header />
    <LoadingDialog
      ref="LoadingDialog"
    />
    <v-container grid-list-md fluid class="container-style">
      <!-- FILTER/SEARCH -->
      <div class="container-header">
        <span>Templates</span>
      </div>
      <v-layout row wrap justify-end>

      </v-layout>

      <!-- TABLE -->
      <v-layout row wrap>
        <v-flex xs12>
          <v-toolbar flat color="white">
            <v-layout row wrap class="mt-2">
              <v-flex xs12 md6>
                <v-toolbar-title>Enrollment Templates</v-toolbar-title>
              </v-flex>
              <v-spacer></v-spacer>

              <EnrollmentTemplateModal
              ref="EnrollmentTemplateModal"
              />

            </v-layout>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :items="enrollmentTemplates"
            class="table-shadow"
          >
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-left">{{ props.item.grade_level_display }}</td>
                <td class="text-xs-left">{{ props.item.payment_plan_display }}</td>
                <td class="text-xs-left">{{ props.item.enrollment_type_display }}</td>
                <td class="text-xs-left">{{ props.item.track_type_display }}</td>
                <td class="text-xs-left">{{ currencyFormat(props.item.total_tuition) }}</td>
                <td>
                    <v-btn
                      @click="editEnrollmentTemplate(props.item)"
                      color="light-gray"
                      :icon="true"
                    >
                      <v-icon
                        color="green darken-4"
                        size="15px"
                      >
                        edit
                      </v-icon>
                    </v-btn>
                    <v-btn
                      @click="removeEnrollmentTemplate(props.item)"
                      color="light-gray"
                      :icon="true"
                    >
                      <v-icon
                        color="red darken-4"
                        size="15px"
                      >
                        delete
                      </v-icon>
                    </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import {
  mapState,
  mapActions
} from "vuex";

import Header from '@/components/Header.vue'
import EnrollmentTemplateModal from '@/components/EnrollmentTemplateModal.vue'
import LoadingDialog from '@/components/LoadingDialog.vue'

export default {
  name: "Home",
  components: {
    Header,
    LoadingDialog,
    EnrollmentTemplateModal,
  },
  computed: {
    ...mapState([
      'enrollmentTemplates',
    ]),
  },
  data() {
    return {
      headers: [
        {
          text: 'Grade Level',
          sortable: true,
          width: '21.25%',
          value: 'grade_level',
        },
        {
          text: 'Payment Plan',
          sortable: false,
          width: '21.25%',
          value: 'payment_plan_display',
        },
        {
          text: 'Enrollment Type',
          sortable: false,
          width: '21.25%',
          value: 'enrollment_type_display',
        },
        {
          text: 'Track Type',
          sortable: false,
          width: '21.25%',
          value: 'track_type_display',
        },
        {
          text: 'Total',
          sortable: false,
          width: '21.25%',
          value: 'total_tuition',
        },
        {
          sortable: false,
          width: '15%',
        },
      ],
    }
  },
  methods: {
    ...mapActions([
      'getEnrollmentTemplates',
      'deleteEnrollmentTemplate',
    ]),
    currencyFormat (total) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'PHP',
        minimumFractionDigits: 2,
      });
      return formatter.format(total)
    },
    editEnrollmentTemplate (enrollmentTemplate) {
      this.$refs.EnrollmentTemplateModal.newEnrollmentTemplate = {
        id: enrollmentTemplate.id,
        grade_level: enrollmentTemplate.grade_level,
        payment_plan: enrollmentTemplate.payment_plan,
        enrollment_type: enrollmentTemplate.enrollment_type,
        track_type: enrollmentTemplate.track_type,
        school_year: enrollmentTemplate.school_year,
        section: enrollmentTemplate.section,
        tuition_fee: enrollmentTemplate.tuition_fee,
        registration_fee: enrollmentTemplate.registration_fee,
        miscellaneous_fee: enrollmentTemplate.miscellaneous_fee,
        computer_fee: enrollmentTemplate.computer_fee,
        books_fee: enrollmentTemplate.books_fee,
        esc_subsidy: enrollmentTemplate.esc_subsidy,
        num_installments: enrollmentTemplate.num_installments,
        installment_amount: enrollmentTemplate.installment_amount,
        books: enrollmentTemplate.books,
      }
      this.$refs.EnrollmentTemplateModal.dialog = true
    },
    removeEnrollmentTemplate (enrollmentTemplate) {
      if (confirm('Are you sure you want to delete this item?')) {
        this.deleteEnrollmentTemplate(enrollmentTemplate)
        .then((data) => {
          this.initialize()
        })
      }
    },
    initialize () {
      this.getEnrollmentTemplates()
    },
  },
  created () {
    this.initialize()

  }
}
</script>
